import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { ApiService } from "../api.service";
import { Chart, registerables } from 'chart.js';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pie-chart',
  //standalone: true,
  //imports: [],
  templateUrl: './pie-chart.component.html',
  styleUrl: './pie-chart.component.scss'
})
export class PieChartComponent implements OnInit, AfterViewInit {
  totalStudies: any = {}; 
  studyCodes: string[];
  selectedStudy: string = '';
  filteredStudyCodes: string[] = [];
  searchText: string = ''; 
  studyNames: string[] = [];
  studyName: string = '';
  uniqueSites: string[] = [];
  responseData: Array<{
    siteLocation: string;
    siteActivityId: number;
    value: string | null;
  }> = [];
  dashboardBarChartData: any[];
  isDropdownVisible: boolean = false;
  pieChartInstance: Chart | null = null;
  barChartInstance: Chart | null = null;

  
  
  constructor(private apiService: ApiService,private route: ActivatedRoute, private router: Router) {
    // Register Chart.js components globally
    Chart.register(...registerables);
  }
  ngOnInit(): void {
    this.loadStudyCounts();
    this.loadStudyList();
    this.onStudySelect();
    if (this.selectedStudy) {
      this.fetchAndRenderChart();
    }
  }

  loadStudyCounts() {
    this.apiService.countTotalStudies().subscribe((data) => {
      this.totalStudies = data.totalStudies;
      
    },
    (error) => {
      console.error('Error fetching study statistics', error);
    }
  );
  }
  loadStudyList(){
    this.apiService.getStudyCodes().subscribe(
      (codes) => {
        this.studyCodes = codes; // Bind the response to the dropdown options
        this.filteredStudyCodes = [...this.studyCodes];
      },
      (error) => {
        console.error('Error fetching study codes:', error);
      }
    );
    
  }
  
  filterStudyCodes() {
    this.filteredStudyCodes = this.studyCodes.filter((code) =>
      code.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }
  toggleDropdown(): void {
    this.isDropdownVisible = !this.isDropdownVisible;
  }
  selectStudy(code: string) {
    this.selectedStudy = code;
    this.isDropdownVisible = false;
    
    this.onStudySelect(); // Trigger study selection logic
    
  }
  
  

onStudySelect() {
  // Check if a study is selected
  if (this.selectedStudy) {
    // Call the API to fetch study names based on the selected study code
    this.apiService.getStudyNames(this.selectedStudy).subscribe({
      next: (response: any) => {
        if (response.studyNames && response.studyNames.length > 0) {
          this.studyName = response.studyNames[0]; // Use the first study name
        } else {
          this.studyName = 'No Study Available'; // Fallback in case the array is empty
        }
      },
      error: (err) => {
        console.error('Error fetching study names:', err);
        this.studyName = 'Error'; // Fallback in case of an error
      }
    });

    // Call the API to fetch dashboard study details based on the selected study code
    this.apiService.getDashboardStudyDetails(this.selectedStudy).subscribe({
      next: (response: any) => {
        if (response?.data) {
          // Type assertion for response data
          this.responseData = response.data as Array<{
            siteLocation: string;
            siteActivityId: number;
            value: string | null;
          }>;

          // Extract unique site locations
          this.uniqueSites = [
            ...new Set(this.responseData.map((item) => item.siteLocation))
          ];
           // Recalculate aggregated data
           const aggregatedData = this.aggregateAndMapData();

           // Re-render pie chart with new data
           this.renderPieChart(aggregatedData);
        }
      },
      error: (err) => {
        console.error('Error fetching study data:', err);
      }
    });

    // Call the API to fetch dashboard bar chart data
    this.apiService.getDashboardbarchart(this.selectedStudy).subscribe({
      next: (response: any[]) => {
        this.dashboardBarChartData = response; // Store or process bar chart data
        console.log('Bar chart data:', this.dashboardBarChartData);
        this.fetchAndRenderChart();
      },
      error: (err) => {
        console.error('Error fetching dashboard bar chart data:', err);
      }
    });
  } else {
    console.warn('No study selected. Please select a study code.');
  }
}


   // Get value for a specific site and activity ID
  getValue(siteLocation: string, siteActivityId: number): string {
    const data = this.responseData.find(
      (item) =>
        item.siteLocation === siteLocation && item.siteActivityId === siteActivityId
    );
    return data?.value || '';
  }
  
  
  ngAfterViewInit(): void {
    if (this.selectedStudy) {
      this.fetchAndRenderChart();
    }
    //this.renderPieChart();
    this.renderBarChart();
  }

    aggregateAndMapData() {
      // Object to store aggregated data
      const activitySums = {
        screening: 0,
        randomization: 0,
        dropout: 0,
        ongoing: 0,
        completed: 0,
      };
    
      // Map for siteActivityId to corresponding activity
      const activityMap = {
        68: 'screening',
        69: 'randomization',
        71: 'dropout',
        72: 'completed',
        86: 'ongoing',
      };
    
      // Aggregate data
      this.responseData.forEach((item) => {
        const activity = activityMap[item.siteActivityId];
        if (activity) {
          activitySums[activity] += parseInt(item.value || '0', 10); // Handle null values
        }
      });
    
      return activitySums;
    }
    renderPieChart(aggregatedData: any) {
      const mainCtx = document.getElementById('mainPieChart') as HTMLCanvasElement;
      const existingChart = Chart.getChart(mainCtx);
  if (existingChart) {
    existingChart.destroy();
  }
      
    
      if (mainCtx) {
        new Chart(mainCtx, {
          type: 'pie',
          data: {
            labels: ['Screening', 'Randomization', 'Dropout', 'Ongoing', 'Completed'],
            datasets: [
              {
                data: [
                  aggregatedData.screening,
                  aggregatedData.randomization,
                  aggregatedData.dropout,
                  aggregatedData.ongoing,
                  aggregatedData.completed,
                ],
                backgroundColor: [
                  '#FF6384',
                  '#36A2EB',
                  '#FFCE56',
                  '#4BC0C0',
                  '#9966FF',
                ],
                hoverOffset: 4,
              },
            ],
          },
          options: {
            responsive: true,
            plugins: {
              legend: {
                position: 'top',
              },
            },
          },
        });
      }
    }
    
    // Fetch data and render chart
    fetchAndRenderChart() {
      if (this.selectedStudy) {
        console.log('Fetching chart data for selected study:', this.selectedStudy);
        this.apiService.getDashboardbarchart(this.selectedStudy).subscribe({
          next: (response: any) => {
            this.dashboardBarChartData = response.data; // Extract data array
            console.log('Fetched bar chart data:', this.dashboardBarChartData);
    
            // Call renderBarChart() after ensuring data is available
            this.renderBarChart();
          },
          error: (err) => {
            console.error('Error fetching dashboard bar chart data:', err);
          }
        });
      } else {
        console.warn('No study selected. Please select a study code.');
      }
    }
    


    /*renderBarChart() {
      const ctx = (document.getElementById('barChart') as HTMLCanvasElement)?.getContext('2d');
    
      if (!ctx) {
        console.error('Bar chart context not found!');
        return;
      }
    
      if (!this.dashboardBarChartData?.length) {
        console.error('No data available for rendering the bar chart!');
        return;
      }

      if (this.barChartInstance) {
        this.barChartInstance.destroy();
      }
    
      const labelSet = new Set<string>();
      const screenedData: number[] = [];
      const randomizedData: number[] = [];
      const totalsamplesizedData: number[] = [];
    
      // Extract unique site locations
      this.dashboardBarChartData.forEach((item: any) => {
        labelSet.add(item.siteLocation);
      });
    
      const labels = Array.from(labelSet);
      console.log('Labels (unique sites):', labels);
      labels.forEach((siteLocation) => {
        // Get values for each metric
        const screened = this.getValue(siteLocation, 68);
        const randomized = this.getValue(siteLocation, 69);
        const totalsamplesized = this.getValue(siteLocation, 91);
    
        console.log(
          `Data for ${siteLocation}: Screened=${screened}, Randomized=${randomized}, TotalSampleSize=${totalsamplesized}`
        );
    
        screenedData.push(Number(screened) || 0);
        randomizedData.push(Number(randomized) || 0);
        totalsamplesizedData.push(Number(totalsamplesized) || 0);
      });
    
      console.log('Screened Data:', screenedData);
      console.log('Randomized Data:', randomizedData);
      console.log('Total Sample Size Data:', totalsamplesizedData);
    
      // Create the bar chart
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Screened',
              data: screenedData,
              backgroundColor: 'rgba(65, 105, 225, 0.8)', // Light blue
              borderColor: 'rgba(65, 105, 225, 1)', // Stronger blue
              borderWidth: 2,
              borderRadius: 5,
            },
            {
              label: 'Randomized',
              data: randomizedData,
              backgroundColor: 'rgba(255, 127, 36, 0.8)', // Orange
              borderColor: 'rgba(255, 127, 36, 1)', // Stronger orange
              borderWidth: 2,
              borderRadius: 5,
            },
            {
              label: 'Total Sample Size',
              data: totalsamplesizedData,
              backgroundColor: '#FFCE56',
              borderColor: '#FFCE56',
              borderWidth: 2,
              borderRadius: 5,
            },
          ],
        },
        options: {
          responsive: true,
          indexAxis: 'y',
          plugins: {
            legend: {
              display: true,
              labels: {
                font: {
                  size: 10,
                  family: 'Arial, sans-serif',
                },
                color: '#333',
                boxWidth: 10,
                boxHeight: 4,
                padding: 1,
              },
            },
            tooltip: {
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              titleFont: {
                size: 10,
              },
              bodyFont: {
                size: 10,
              },
              borderWidth: 1,
              borderColor: '#fff',
            },
          },
          scales: {
            x: {
              beginAtZero: true,
              title: { // Add the title object here
                display: true,
                text: 'values', // Label for the X-axis
                font: {
                  size: 14,
                  family: 'Arial, sans-serif',
                },
                color: '#333',
              },
              ticks: {
                stepSize: 10,
                font: {
                  size: 12,
                  family: 'Arial, sans-serif',
                },
              },
            },
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Site Locations', // Label for the Y-axis
                font: {
                  size: 14,
                  family: 'Arial, sans-serif',
                },
                color: '#333',
              },
              ticks: {
                autoSkip: false,
                font: {
                  size: 12,
                  family: 'Arial, sans-serif',
                },
                padding: 3,
                callback: function (value) {
                  const siteLocation = labels[value]; // Map tick value to siteLocation label
                  if (siteLocation) {
                    // Split long names into multiple lines
                    const words = String(siteLocation).split(' ');
                    const maxWordsPerLine = 1; // Customize number of words per line
                    const lines = [];
                    for (let i = 0; i < words.length; i += maxWordsPerLine) {
                      lines.push(words.slice(i, i + maxWordsPerLine).join(' '));
                    }
                    return lines;
                  }
                  return value;
                },
                
              },
            },
          },
        },
      });
    }*/
      renderBarChart() {
        const barCtx = (document.getElementById('barChart') as HTMLCanvasElement)?.getContext('2d');
      
        if (!barCtx) {
          console.error('Bar chart context not found!');
          return;
        }
      
        if (!this.dashboardBarChartData?.length) {
          console.error('No data available for rendering the bar chart!');
          return;
        }
      
        // Destroy existing chart instance if it exists
        if (this.barChartInstance) {
          this.barChartInstance.destroy();
        }
      
        const labelSet = new Set<string>();
        const screenedData: number[] = [];
        const randomizedData: number[] = [];
        const totalsamplesizedData: number[] = [];
      
        // Extract unique site locations
        this.dashboardBarChartData.forEach((item: any) => {
          labelSet.add(item.siteLocation);
        });
      
        const labels = Array.from(labelSet);
        labels.forEach((siteLocation) => {
          const screened = this.getValue(siteLocation, 68);
          const randomized = this.getValue(siteLocation, 69);
          const totalsamplesized = this.getValue(siteLocation, 91);
      
          screenedData.push(Number(screened) || 0);
          randomizedData.push(Number(randomized) || 0);
          totalsamplesizedData.push(Number(totalsamplesized) || 0);
        });
      
        // Create the bar chart
        this.barChartInstance = new Chart(barCtx, {
          type: 'bar',
          data: {
            labels,
            datasets: [
              {
                label: 'Screened',
                data: screenedData,
                backgroundColor: 'rgba(65, 105, 225, 0.8)', // Light blue
                borderColor: 'rgba(65, 105, 225, 1)', // Stronger blue
                borderWidth: 2,
                borderRadius: 5,
              },
              {
                label: 'Randomized',
                data: randomizedData,
                backgroundColor: 'rgba(255, 127, 36, 0.8)', // Orange
                borderColor: 'rgba(255, 127, 36, 1)', // Stronger orange
                borderWidth: 2,
                borderRadius: 5,
              },
              {
                label: 'Total Sample Size',
                data: totalsamplesizedData,
                backgroundColor: '#FFCE56',
                borderColor: '#FFCE56',
                borderWidth: 2,
                borderRadius: 5,
              },
            ],
          },
          options: {
            responsive: true,
            indexAxis: 'y',
            plugins: {
              legend: {
                display: true,
                labels: {
                  font: {
                    size: 10,
                    family: 'Arial, sans-serif',
                  },
                  color: '#333',
                  boxWidth: 10,
                  boxHeight: 4,
                  padding: 1,
                },
              },
              tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                titleFont: {
                  size: 10,
                },
                bodyFont: {
                  size: 10,
                },
                borderWidth: 1,
                borderColor: '#fff',
              },
            },
            scales: {
              x: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Values',
                  font: {
                    size: 14,
                    family: 'Arial, sans-serif',
                  },
                  color: '#333',
                },
                ticks: {
                  stepSize: 10,
                  font: {
                    size: 12,
                    family: 'Arial, sans-serif',
                  },
                },
              },
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Site Locations',
                  font: {
                    size: 14,
                    family: 'Arial, sans-serif',
                  },
                  color: '#333',
                },
                ticks: {
                  autoSkip: false,
                  font: {
                    size: 12,
                    family: 'Arial, sans-serif',
                  },
                  padding: 3,
                  callback: function (value) {
                    const siteLocation = labels[value]; // Map tick value to siteLocation label
                    if (siteLocation) {
                      const words = String(siteLocation).split(' ');
                      const maxWordsPerLine = 1;
                      const lines = [];
                      for (let i = 0; i < words.length; i += maxWordsPerLine) {
                        lines.push(words.slice(i, i + maxWordsPerLine).join(' '));
                      }
                      return lines;
                    }
                    return value;
                  },
                },
              },
            },
          },
        });
      }
      
    goToDashboard() {
      this.router.navigate(['/users-list']);
    }
    goToDashboard1() {
      this.router.navigate(['/study-list']);
    }
    goBack(): void {
      this.router.navigate(['/home'], {
        
      });
    }
  }    

